import React from 'react';
import ImageGallery from './ImageGallery';
import TaletreeLoader from '../taletree_loader/TaletreeLoader';

const FeedGallery = ({
  feedList,
  handleBinky,
  handleScroll,
  handleComment,
  isLoading,
  isCampRoom = false,
}) => {
  const getFeed =
    feedList !== null && feedList.length > 0 ? (
      <ImageGallery
        {...{ feedList, handleBinky, handleScroll, handleComment, isCampRoom }}
      />
    ) : isLoading ? (
      // <TaletreeLoader />
      <></>
    ) : (
      <div className="home-feed-no-creation-text-wrapper">
        <h4>There were no creations submitted in this category.</h4>
      </div>
    );
  return <>{getFeed}</>;
};

export default FeedGallery;
